import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Preset.types';
import { IPreset } from './Preset.lib';

export class PresetImportarExcel extends IPreset
{

    public static async create( id: number ): Promise<IPreset>
    {
        let o = new PresetImportarExcel();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/ventas/importar/presets';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<PresetImportarExcel>; Error?: boolean; }>
    {

        let a: Array<PresetImportarExcel> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/ventas/importar/presets` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new PresetImportarExcel( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            delete js.id;
            req.body = js;
            if ( this.Existe )
            {
                js.id = this.Id;
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    return true;
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    return true;
                }
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

}